import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const KIOSKCODESCANNERBLOCK_LEGACY_FIELD_ORDER = [
  "accent_color",
  { type: "separator" },
  "redirect_url",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCodeScannerBlockDescriptor: _generatedKioskCodeScannerBlockDescriptor,
  kioskCodeScannerBlockBlocDefinition,
  kioskCodeScannerBlockDashboardLayout,
  kioskCodeScannerBlockConfig,
  kioskCodeScannerBlockResolveConfig,
  kioskCodeScannerBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Code Scanner",
    componentType: "KioskCodeScannerBlockComponent",
    category: "kiosk",
    description: "Kiosk Code Scanner.",
    keywords: [],
    allowed_in: ["GenericPage"],
    sharedFields: {},
  },

  () => ({
    accent_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-600" },
      options: {
        label: "pages.blocks.kiosk-code-scanner.accent-color.label",
      },
    }),
    redirect_url: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.kiosk-code-scanner.redirect-url.label",
        help: "pages.blocks.kiosk-code-scanner.redirect-url.help",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-code-scanner.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-code-scanner.fieldset.scanner.label",
            fields: ["redirect_url", "accent_color"],
          },
        ],
      },
    ],
  }),
);

export function kioskCodeScannerBlockDescriptor(): IBlockDescriptor;
export function kioskCodeScannerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCodeScannerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCodeScannerBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedKioskCodeScannerBlockDescriptor,
    kioskCodeScannerBlockProperties,
    fieldOrder,
  );
}

export {
  kioskCodeScannerBlockBlocDefinition,
  kioskCodeScannerBlockDashboardLayout,
  kioskCodeScannerBlockProperties,
  kioskCodeScannerBlockConfig,
  kioskCodeScannerBlockResolveConfig,
};

export type KioskCodeScannerBlockConfig = typeof kioskCodeScannerBlockConfig;
